import { useBoolean } from "@/hooks/use-boolean";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";
import { PropsWithChildren, useCallback } from "react";
import { RoutingLocationRuleForm } from "./routing-location-rule-form";

export const AddRoutingLocationRulesDialog = ({
  children,
}: PropsWithChildren<{}>) => {
  const t = useTranslation();
  const open = useBoolean(false);
  const onClose = useCallback(() => {
    open.setFalse();
  }, []);

  return (
    <Dialog open={open.value} onOpenChange={open.setValue}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="pt-10">
        <DialogHeader>
          <DialogTitle>{t("settings.shipping.rules.addRuleTitle")}</DialogTitle>
          <DialogDescription>
            {t("settings.shipping.rules.ruleDescription")}
          </DialogDescription>
        </DialogHeader>
        <RoutingLocationRuleForm onCloseForm={onClose} />
      </DialogContent>
    </Dialog>
  );
};
